import angular from 'angular';
import Rx from 'rx';
import DialogController from "./dialog";

export default function MemberAccountTradeNoteCtrl($scope, $sce, $mdDialog, $wamp, $stateParams, $state, UserService, progressBar) {

  if ($stateParams.noteId === "0") {
    return;
  }
  var user = Rx.Observable.fromPromise(UserService.load()).share();
  var notesUri = 'org.eggs.trade_notes';

  var s1 = user
      .do(function () {
        progressBar.add(notesUri);
      })
      .flatMap(function (user) {
        return $wamp.call(notesUri, [$stateParams.id, user.id]);
      })
      .flatMap(function (notes) {
        return Rx.Observable.from(notes);
      })
      .filter(function (note) {
        return note.NoteID.toString() === $stateParams.noteId;
      })
      .subscribe(function (note) {
        progressBar.remove(notesUri);
        $scope.$apply(function () {
          $scope.note = note;
        });
      });

  $wamp.call("org.eggs.get_image_key_for_note", [$stateParams.noteId, $stateParams.id]).then(
      function (key) {
        $scope.url = $sce.trustAsResourceUrl("https://" + __API_HOST__ + "/api3/image?token=" + key);
        // $scope.url = $sce.trustAsResourceUrl("http://localhost:8000/image?token=" + key);
        $mdDialog.show({
          controller: ['$scope', '$mdDialog', DialogController],
          template: require('../views/notes-dialog.html'),
          parent: angular.element(document.body),
          //targetEvent: ev,
          clickOutsideToClose: true,
          openFrom: '#note' + $stateParams.noteId,
          closeTo: '#note' + $stateParams.noteId,
          fullscreen: true,
          scope: $scope,
          preserveScope: true,
          onRemoving: function () {
            $state.go('^');
          }
        });
      });

  $scope.$on('$destroy', function () {
    s1 && s1.dispose();
  });
}
